import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { chartColors, RtoBarChartConstants } from '@shared/constants/global.enum';

@Component({
  selector: 'app-rto-bar-chart',
  templateUrl: './rto-bar-chart.component.html',
  styleUrls: ['./rto-bar-chart.component.scss'],
})
export class RtoBarChartComponent implements OnInit {
  barChartLabels: string[] = [];
  barChartData: any[] = [];
  barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: RtoBarChartConstants.legendPosition,
        labels: {
          usePointStyle: true,
          font: {
            size: RtoBarChartConstants.legendFontSize,
          },
          color: chartColors.textDark,
        },
      },
      tooltip: {
        enabled: true,
        backgroundColor: chartColors.tooltipBackground,
        titleColor: chartColors.tooltipTitle,
        bodyColor: chartColors.tooltipBody,
        borderColor: chartColors.dividerGrey,
        borderWidth: RtoBarChartConstants.toolTipBorderWidth,
      },
      datalabels: {
        color: chartColors.backgroundWhite,
        anchor: RtoBarChartConstants.dataLabelAnchor,
        align: RtoBarChartConstants.dataLabelAlign,
        font: {
          size: RtoBarChartConstants.dataLabelFontSize,
        },
      },
    },
    hover: {
      mode: null,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
          drawTicks: true,
        },
        ticks: {
          display: true,
          align: RtoBarChartConstants.tickAlign,
          font: {
            size: RtoBarChartConstants.tickFontSize,
            color: chartColors.textDark,
          },
        },
        barThickness: RtoBarChartConstants.xBarThickness,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false,
          color: chartColors.dividerGrey,
          drawTicks: true,
        },
        ticks: {
          display: true,
          align: RtoBarChartConstants.tickAlign,
          font: {
            size: RtoBarChartConstants.tickFontSize,
            color: chartColors.textDark,
          },
          stepSize: RtoBarChartConstants.yTickStepSize,
        },
      },
    },
  };
  chartType: ChartType = 'bar';
  generateYearlyData(): void {
    const now = new Date();
    const labels: string[] = [];
    const compliantData: number[] = [];
    const nonCompliantData: number[] = [];

    for (let i = 0; i < 12; i++) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - i);
      const monthLabel =
        monthDate.toLocaleString('default', { month: 'short' }) +
        ' ' +
        monthDate.getFullYear();
      labels.unshift(monthLabel);
      compliantData.unshift(Math.floor(Math.random() * 100));
      nonCompliantData.unshift(Math.floor(Math.random() * 100));
    }

    this.barChartLabels = labels;
    this.barChartData = [
      {
        data: compliantData,
        label: RtoBarChartConstants.barChartLabelCompliant,
        backgroundColor: chartColors.mintGreen,
      },
      {
        data: nonCompliantData,
        label: RtoBarChartConstants.barChartLabelNonCompliant,
        backgroundColor: chartColors.darkOrange,
      },
    ];
  }
  ngOnInit(): void {
    this.generateYearlyData();
  }
}
